import { render, staticRenderFns } from "./LegalDocumentDetails.vue?vue&type=template&id=1e730da6&scoped=true&"
import script from "./LegalDocumentDetails.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e730da6",
  null
  
)

export default component.exports